import {styles} from "./styles/SmallScreenTopMenuHorizontalDivider.style";


const SmallScreenTopMenuHorizontalDivider = () => (
  <div style={styles.SmallScreenTopMenuHorizontalDivider}></div>
)

export default SmallScreenTopMenuHorizontalDivider;